import { render, staticRenderFns } from "./ScrollableContainerWithStickyHeader.vue?vue&type=template&id=b13d8776&scoped=true&"
import script from "./ScrollableContainerWithStickyHeader.vue?vue&type=script&lang=js&"
export * from "./ScrollableContainerWithStickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableContainerWithStickyHeader.vue?vue&type=style&index=0&id=b13d8776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13d8776",
  null
  
)

export default component.exports